import { BlobImage } from "./BlobImage";
import { StatusBadge } from "./StatusBadge";
import type { Issue } from "../services/db/schema";

interface IssueCardProps {
  issue: Issue;
  onOpen: () => void;
}

export function IssueCard({ issue, onOpen }: IssueCardProps): JSX.Element {
  return (
    <article className="issue-card">
      <button className="issue-card__button" type="button" onClick={onOpen} aria-label="Open condition note">
        <span className="issue-card__photo">
          <BlobImage blobKey={issue.photoThumbBlobKey} alt="Condition note photo thumbnail" />
        </span>
        <span className="issue-card__status">
          <StatusBadge status={issue.transcriptionStatus} />
        </span>
      </button>
    </article>
  );
}
